import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router';
import {Stack, Tab, Tabs} from '@mui/material';
import {AutoAwesome, Search, Work} from '@mui/icons-material';
import TabPanel from './TabPanel';
import AIExpertSuggestions from './AIExpertSuggestions';
import ManualExpertSearch from './ManualExpertSearch';
import PostToJobBoard from './PostToJobBoard';

const FindExpert = () => {
    const [searchParams] = useSearchParams();
    const expertTab = searchParams.get('expertTab');

    const [tabValue, setTabValue] = useState(() => {
        if (expertTab === 'ai_suggest') return 0;
        if (expertTab === 'job_board') return 2;
        return 0;
    });

    useEffect(() => {
        if (expertTab === 'ai_suggest') {
            setTabValue(0);
        } else if (expertTab === 'job_board') {
            setTabValue(2);
        }
    }, [expertTab]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Stack height={'100%'} overflow="hidden">
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="fullWidth"
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    minHeight: 40,
                    '& .MuiTab-root': {
                        minHeight: 40,
                        py: 0,
                        fontSize: '0.75rem',
                        textTransform: 'none'
                    }
                }}
            >
                <Tab
                    icon={<AutoAwesome sx={{fontSize: 16}}/>}
                    iconPosition="start"
                    label="AI Suggest"
                />
                <Tab
                    icon={<Search sx={{fontSize: 16}}/>}
                    iconPosition="start"
                    label="Search"
                />
                <Tab
                    icon={<Work sx={{fontSize: 16}}/>}
                    iconPosition="start"
                    label="Job Board"
                />
            </Tabs>

            <TabPanel value={tabValue} index={0}>
                <AIExpertSuggestions/>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <ManualExpertSearch/>
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <PostToJobBoard/>
            </TabPanel>
        </Stack>
    );
};

export default FindExpert;
